import { Injectable } from '@angular/core';
import { AngularFireList, AngularFireDatabase } from 'angularfire2/database';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  eventsChange= new BehaviorSubject<any[]>(null);
  events:any[]=[];
  eventsList:AngularFireList<any>;
  constructor(private firebase:AngularFireDatabase,) { }
  getEventsList(){
    this.eventsList=this.firebase.list('events');  
    this.eventsList.snapshotChanges().subscribe(
      list=>{
      this.events=  list.map(item=>{ return item.payload.val();})
      this.events = this.events.reverse();
      this.eventsChange.next(this.events)
      // this.setCarousel(this.news.reverse());
      }
    )
  }

  getEvents(){
    return this.events.slice();
  }
}
